// ABOUTME: Context set by HeaderBarActionsMenu so a HeaderBarIconButton renders as an entry of the open menu.
// ABOUTME: Kept in its own file to avoid an import cycle between the menu and the button.

import { createContext } from 'react';

export interface HeaderBarMenuContextValue {
    /** The open menu's list element the actions render their MenuItem into; null while closed. */
    container: HTMLElement | null;
    close: () => void;
    /**
     * The menu's button in the bar. Stays set after the menu closes, so an action that opens a
     * popover of its own can anchor it there: the entry it was clicked from is gone by then.
     */
    trigger: HTMLElement | null;
}

export const HeaderBarMenuContext = createContext<HeaderBarMenuContextValue | null>(null);
